export default __webpack_public_path__ + "static/software_big-15bbe20ea474273d61938f260f242524.jpg";